import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { Calendar, MapPin, User, PlayCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

import { MAIN_COLOR } from "../util/theme";

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveTab = () => {
    const path = location.pathname;
    if (path === "/map") return "map";
    if (path === "/profile") return "profile";
    if (path === "/content" || path === "/stats") return "content";
    return "list";
  };

  const activeTab = getActiveTab();

  const activeColor = MAIN_COLOR;
  const inactiveColor = useColorModeValue("gray.450", "gray.500");
  const bg = useColorModeValue("rgba(255, 255, 255, 0.95)", "rgba(26, 32, 44, 0.95)");
  const borderColor = useColorModeValue("#E2E8F0", "whiteAlpha.200");

  const navigationItems = [
    { key: "list", label: t("list"), icon: Calendar, path: "/" },
    { key: "map", label: t("map"), icon: MapPin, path: "/map" },
    { key: "profile", label: t("profile"), icon: User, path: "/profile" },
    { key: "content", label: t("content"), icon: PlayCircle, path: "/content" },
  ];

  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      height="66px"
      bg={bg}
      backdropFilter="blur(16px)"
      borderTop="1px solid"
      borderColor={borderColor}
      zIndex={100}
      px={4}
    >
      <Flex justify="space-around" align="center" h="100%" maxW="500px" mx="auto">
        {navigationItems.map((item) => {
          const isActive = activeTab === item.key;
          const IconComponent = item.icon;
          return (
            <Flex
              key={item.key}
              direction="column"
              alignItems="center"
              justifyContent="center"
              cursor="pointer"
              onClick={() => navigate(item.path)}
              transition="all 0.2s ease"
              _active={{ transform: "scale(0.95)" }}
              flex="1"
            >
              <Box color={isActive ? activeColor : inactiveColor} mb="2px">
                <IconComponent size={22} strokeWidth={isActive ? 2.5 : 2} />
              </Box>
              <Text
                fontSize="11px"
                fontWeight={isActive ? "800" : "bold"}
                color={isActive ? activeColor : inactiveColor}
              >
                {item.label}
              </Text>
            </Flex>
          );
        })}
      </Flex>
    </Box>
  );
};

export default Footer;